<template>
  <div v-if="this.type == 'aircon'">
    <Aircon
      v-if="this.calldata[0]"
      :calldata="this.calldata"
      :type="this.type"
      :sensorid="this.sensorid"
    />
  </div>
  <div v-else-if="this.type == 'relay'">
    <Relay :type="this.type" />
  </div>
  <div v-else>
    <vs-breadcrumb>
      <li>
        <a
          aria-current="page"
          style="color: rgba(0, 0, 0, 0.4)"
          title="Device Management"
          >Device Management</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'sensor'" title="Device">Device</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Sensor</li>
    </vs-breadcrumb>
    <vs-row vs-w="12" v-if="this.username != 'poonsak.ngk'">
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card style="border-radius: 20px">
          <div class="mt-2" slot="header">
            <h4>
              {{ sensorname }}
            </h4>
          </div>
          <vs-row vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="4"
              class="p-3"
              vs-sm="4"
              vs-xs="4"
            >
              <img
                src="../../../../assets/images/sensor/sensor.jpg"
                width="200"
                height="100"
              />
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-align="center"
              vs-lg="7"
              vs-sm="7"
              vs-xs="8"
            >
              <div style="width: 100%">
                <vs-row vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Name</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ sensorname }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold textNowrap"
                      >Serial Number</span
                    >
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ sensorid }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Type</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ type }}</span>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Network</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>{{ nwname }}</span>
                  </vs-col>
                </vs-row>
                <vs-row
                  v-if="statussensor || type == 'control'"
                  class="mt-3"
                  vs-w="12"
                >
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Status</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>Active</span>
                  </vs-col>
                </vs-row>
                <vs-row v-else class="mt-3" vs-w="12">
                  <vs-col
                    class="textRight textResponsive"
                    vs-lg="3"
                    vs-sm="4"
                    vs-xs="4"
                  >
                    <span class="font-weight-bold">Status</span>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="8" vs-xs="8">
                    <span>Inactive</span>
                  </vs-col>
                </vs-row>
              </div>
            </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>

    <vs-card v-if="this.type == 'control'">
      <h4 class="card-title d-flex">Control Status</h4>
    </vs-card>

    <vs-row v-if="this.type == 'control'">
      <Control
        v-if="this.calldata[0]"
        :id="this.sensorid"
        :gid="this.gatewayid"
        :nwid="this.nwid"
        :nwname="this.nwname"
        :type="this.type"
      />
    </vs-row>

    <!-- <vs-button type="filled" icon="keyboard_backspace" color="#333f50" @click="back()">Back</vs-button> -->

    <!-- <vs-col vs-lg="6" vs-xs="12">
      <AlertState v-if="this.calldata[0]" :id="this.sensorid" :calldata="this.calldata" :nwid="this.nwid" :nwname="this.nwname" :type="this.type" />
    </vs-col> -->
    <vs-col vs-lg="12" vs-xs="12">
      <Lastest
        v-if="this.calldata[0]"
        :id="this.sensorid"
        :calldata="this.calldata"
        :nwid="this.nwid"
        :nwname="this.nwname"
        :type="this.type"
      />
    </vs-col>
    <vs-row vs-w="12">
      <vs-col vs-lg="12" vs-xs="12" v-if="this.calldata[0]">
        <vs-card style="border-radius: 20px">
          <vs-tabs v-if="this.username != 'poonsak.ngk'">
            <vs-tab label="History Log">
              <div class="con-tab-ejemplo mt-4">
                <State
                  v-if="this.calldata[0]"
                  :name="this.sensorname"
                  :id="this.sensorid"
                  :calldata="this.calldata"
                  :nwid="this.nwid"
                  :nwname="this.nwname"
                  :type="this.type"
                />
              </div>
            </vs-tab>

            <vs-tab label="Chart Data">
              <div class="con-tab-ejemplo mt-4">
                <Data
                  v-if="this.calldata[0]"
                  :id="this.sensorid"
                  :calldata="this.calldata"
                  :type="this.type"
                  :gid="this.gatewayid"
                  :lora="this.lora"
                />
              </div>
            </vs-tab>
            <vs-tab label="Alert">
              <div class="con-tab-ejemplo mt-4">
                <vs-row>
                  <vs-col>
                    <vs-row class="mb-4 mt-1">
                      <h4>Alert</h4>
                    </vs-row>
                    <div class="table-responsive ">
                      <vs-table :data="alertlistdata" style="color: #333f50">
                        <template slot="thead">
                          <vs-th
                            id="noWrap"
                            v-for="(head, indexh) in alertheaderlist"
                            :key="indexh"
                            sort-key="alertname"
                          >
                            {{ head }}
                             <span
                          ><vs-icon icon="unfold_more" size="13px"></vs-icon
                        ></span>
                          </vs-th>
                        </template>
                        <template slot-scope="{ data }">
                          <vs-tr
                            id="fontSizeData"
                            :key="indextr"
                            v-for="(tr, indextr) in data"
                          >
                            <vs-td>
                              {{ data[indextr].alertname }}
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].condition }}
                              <!-- <p
                                v-for="(condition, index) in condata"
                                :key="index"
                              >
                                {{ condition.con }} {{ condition.value }}
                              </p> -->
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].sensorname }}
                            </vs-td>
                            <vs-td>
                              {{ data[indextr].date }}
                            </vs-td>
                            <vs-td>
                              <span v-if="data[indextr].status == true"
                                >Active</span
                              >
                              <span v-if="data[indextr].status == false"
                                >Deactive</span
                              >
                            </vs-td>
                            <vs-td>
                              <p
                                v-for="(item, i) in Object.keys(
                                  data[indextr].ReadingData
                                )"
                                :key="i"
                              >
                                <template
                                  v-if="
                                    item != 'date' &&
                                    item != 't' &&
                                    item != 'time' &&
                                    item != 'timestamp' &&
                                    item != 'rssi'
                                  "
                                >
                                  {{ item }}:
                                  {{ data[indextr].ReadingData[item] }}
                                </template>
                              </p>
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </vs-col>
                </vs-row>
              
                
              </div>
            </vs-tab>
          </vs-tabs>
          <vs-tabs v-else>
            <vs-tab label="History Log">
              <div class="con-tab-ejemplo mt-4">
                <State
                  v-if="this.calldata[0]"
                  :name="this.sensorname"
                  :id="this.sensorid"
                  :calldata="this.calldata"
                  :nwid="this.nwid"
                  :nwname="this.nwname"
                  :type="this.type"
                />
              </div>
            </vs-tab>
            <vs-tab label="Chart Data">
              <div class="con-tab-ejemplo mt-4">
                <Data
                  v-if="this.calldata[0]"
                  :id="this.sensorid"
                  :calldata="this.calldata"
                  :type="this.type"
                  :gid="this.gatewayid"
                  :lora="this.lora"
                />
              </div>
            </vs-tab>
          </vs-tabs>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import Data from "../../dashboard/Sensor/Data.vue";
import State from "../../dashboard/Sensor/State";
import Control from "../../dashboard/Sensor/Control";
import Lastest from "../../dashboard/Sensor/Lastest";
import Aircon from "../../dashboard/Sensor/Aircon.vue";
import Relay from "../../dashboard/Sensor/Relay.vue";

export default {
  name: "MailboxDashboard",
  props: ["name", "mode"],
  components: {
    Aircon,
    Relay,
    Data,
    State,
    Control,
    Lastest,
  },
  data: () => ({
    nwid: "",
    alertlog: "",
    nwname: "",
    username: "",
    sensorname: "",
    statussensor: "",
    sensorid: "",
    gatewayid: "",
    idsensor: "",
    token: "",
    type: "",
    fan: "",
    condata: [],
    temp: 0,
    alertlistdata: [],
    alertheaderlist: [
      "Alert Name",
      "Condition",
      "Sensor Name",
      "Alert Timestamp",
      "Status",
      "Reading Data",
    ],
    options1: ["Min", "Low", "Medium", "High", "Max", "Auto"],
    options2: ["Off", "Auto", "Cool", "Heat", "Dry", "Fan"],
    airmode: "",
    random: [],
    random2: [],
    calldata: [],
    count: [],
    sensdata: [{}],
    maxcount: 0,
    lora: "",
  }),
  methods: {
    statechange(bool) {
      this.$API.post("updatestate/" + this.sensorid, {
        Protocol: this.calldata[0].protocol,
        Power: bool,
        Mode: this.airmode,
        Temp: this.temp,
        Fan: this.fan,
        state: true,
      });
    },
    Test() {
      this.State += 1;
    },
    back() {
      this.$router.push({
        name: "ViewNetwork",
        params: {
          name: this.nwname,
          id: this.nwid,
        },
      });
    },
    Max(num) {
      if (this.maxcount <= num) this.maxcount = num;
    },
  },
  mounted() {
    this.nwname = this.$session.get("nwname");
    this.nwid = this.$session.get("nwid");
    this.sensorname = this.$session.get("sensorname");
    this.sensorid = this.$session.get("sensorid");
    this.gatewayid = this.$session.get("gatewayid");
    this.statussensor = this.$session.get("statussensor");
    this.type = this.$session.get("type");
    this.lora = this.$session.get("lora");
    this.idsensor = this.$session.get("idsensor");
    this.username = this.$session.get("username");
    this.token = this.$session.get("token");
    // console.log(
    //   this.nwname,
    //   this.nwid,
    //   this.sensorid,
    //   this.gatewayid,
    //   this.type,
    //   this.lora,
    //   this.sensorname,
    //   this.username,
    //   this.mode
    // );
    this.$vs.loading();
    this.$API.get("alertlog/user").then((alertlog) => {
      console.log(alertlog.data);
      this.$API
        .get("findid/" + this.sensorname + "/" + this.sensorid)
        .then((result) => {
          this.$API
            .get("alertlog/user/sensor/" + result.data[0].id)
            .then((sensorlog) => {
              console.log(sensorlog.data);
              sensorlog.data.forEach((elSen) => {
                alertlog.data.forEach((elAlert, i) => {
                  if (elSen.sensorname == elAlert.sensorname) {
                    elAlert.alerthistory.forEach((history) => {
                      if (history.alertstatus) {
                        this.alertlistdata.push({
                          alertname: alertlog.data[i].alertname,
                          condition: history.message,
                          date: this.$moment(history.timestamp).format(
                            "YYYY-MM-DD HH:mm:ss"
                          ),
                          sensorname: alertlog.data[i].sensorname,
                          ReadingData: history.lastdata[0],
                          status: history.alertstatus,
                        });
                      }
                    });
                    // this.condata = element.con;
                    // console.log(this.condata[0])
                  }
                });
              });
            });
        })
        .catch((err) => {
          console.log(err);
        });
    });
    if (this.mode == 1) {
      if (this.type != "aircon") this.$vs.loading();
      this.$API
        .post("sensorname", {
          name: this.name,
        })
        .then((result) => {
          this.calldata = result.data;
          // :id="this.sensorid" :calldata="this.calldata" :type="this.type" :gid="this.gatewayid"
          this.sensorid = this.calldata[0].sensorid;
          // this.type = 'monnit'
          this.gatewayid = this.calldata[0].gatewayid;
          // console.log(this.sensorid,this.type,this.gatewayid,this.calldata,this.lora)
          setTimeout(() => {
            this.$vs.loading.close();
          }, 100);
        });
    } else {
      console.log("sensordatashort/" + this.sensorid + "/" + this.gatewayid);
      this.$API
        .get("sensordatashort/" + this.sensorid + "/" + this.gatewayid)
        .then((result) => {
          console.log(result.data);
          this.calldata = result.data;
          if (this.type == "aircon") {
            this.temp = this.calldata[0].temp;
            this.fan = this.calldata[0].fan;
            this.airmode = this.calldata[0].mode;
          }
          if (this.type == "advantech" || this.type == "ssc") {
            this.calldata.forEach((element) => {
              // // console.log(element.t)
              element.Timestamp = this.$moment(element.t).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              delete element.t;
              delete element.q;
              delete element.c;
              delete element.s;
            });
          }
          this.calldata.forEach((element) => {
            delete element.users_id;
          });
          setTimeout(() => {
            this.$vs.loading.close();
          }, 100);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
};
</script>
<style scoped>
.cssTable {
  border-radius: 20px;
  background-color: #f2f3f4;
}
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem;
}
img {
  max-width: 100%;
  height: auto;
}

.textRight {
  text-align: right;
}
@media only screen and (max-width: 530px) {
  .textResponsive {
    text-align: left;
  }
}
</style>

